import Vue from "vue";
import { axios, urlList } from "./common.js";
/**店铺积分充值
 * @param {Object} data
 */
/*  export const mchPayIntegralRecharge = function(data) {

  return axios.post("ServiceProvider/v2/Pay/integral/recharge",JSON.stringify(data));
} */
/**
 *  获取店铺配置支付信息
 * /merchant/v2/pay/GetConfigure
 *  merchant_id店铺id
 * 微信店铺号
 */
export const paySubmit = function () {
  var data = {
    out_sheet_no: Vue.prototype.getKey(),
    service_no: "0000000000",
    amount: 1,
    payer_no: "0000000000",
    trade_way: "WXJSPAY",
    remark: "通道充值",
    use_to: 1,
    user_no: "4973645190"
  };
  console.log(JSON.stringify(data));
  return axios.post("v3/ServiceProvider/Pay/Pay/submit", JSON.stringify(data));
};

/**
 * 获取SHA256withRSA
 */
export const getSHA256WithRSA = function (str) {
  var data = {
    plaintext: str
  };

  /* console.log("签名参数--------------------", JSON.stringify(data));
  return $post(JSON.stringify(data), `wxhelper/v2/common/SHA256WithRSA`, "web");
  // return $get(`wxhelper/v2/common/SHA256WithRSA?plaintext=${str}`);
  const url = pjUrl(1, `wxhelper/v2/common/SHA256WithRSA?plaintext=${str}`, "web");*/
  //TODO: 获取令牌接口换了应该
  return new Promise((resolve, reject) => {
    return axios
      .post("v3/Common/Security/SHA256WithRSASIGN", JSON.stringify(data))
      .then(res => {
        resolve(res.data.resp_data);
      });
  });
};

/**
 * 获取远程文件对象
 * @returns
 */
//TODO: 修改地址为正式地址
export const getFile = function () {
  return axios.get(urlList[1] + "/media/label").then(res => {
    const reg = />\S*.json/g; //正则表达式 />
    var list = []; //模板名列表
    var obj = {}; //正则表达式读取出的列表
    var i = 1;
    while (i) {
      obj[i] = reg.exec(res.data);
      if (obj[i] == null || !obj[i]) {
        i = 0;
        break;
      } else {
        i++;
      }
    }
    for (let key in obj) {
      if (obj[key] && obj[key] != null) {
        list.push(obj[key][0].replace(">", "").replace(".json", ""));
      }
    }
    return list;
  });
};
/**
 * 获取文件详情
 * @returns 模板详情
 */
export const getFileDetail = function (tempname) {
  return new Promise((resolve, reject) => {
    const url = encodeURI(urlList[1] + "/media/label/" + tempname + ".json");
    // console.log(url);
    return axios
      .get(url)
      .then(res => {
        resolve(res);
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 * 获取视频路径
 * @returns
 */
//TODO: 修改地址为正式地址
export const getVideoUrl = function () {
  return axios.get("https://pan.hakspay.cn/SOFTWARE/video/education/tiger").then(res => {
    const reg = />\S*.mp4</g; //正则表达式 />
    var list = []; //视频列表
    var obj = {}; //正则表达式读取出的列表
    var i = 1;
    while (i) {
      obj[i] = reg.exec(res.data);

      if (obj[i] == null || !obj[i]) {
        i = 0;
        break;
      } else {
        i++;
      }
    }
    for (let key in obj) {
      if (obj[key] && obj[key] != null) {
        list.push({
          name: obj[key][0].replace(">", "").replace(".mp4<", ""),
          src: `https://pan.hakspay.cn/SOFTWARE/video/education/tiger/${obj[
            key
          ][0]
            .replace(">", "")
            .replace("<", "")}`
        });
      }
    }
    return list;
  });
};

/**
 * 获取网页资源
 * @param {string} url 网页资源的url地址
 * @returns {string} 返回html格式的字符串
 */
export const getAssets = async function (url) {
  const res = await axios.get(url);
  // console.log("getAssets",res);
  return res;
};
